ApiAjax = require 'app/scripts/network/api-ajax'
Auth = require 'app/scripts/db/auth'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Reaction = require 'app/scripts/models/reaction'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'


getIdEmoji = (reaction) ->
  currentEmoji = reaction.get('emoji')
  currentIdEmoji =
    if currentEmoji.unified?
      currentEmoji.unified.toUpperCase()
    else
      currentEmoji
  return currentIdEmoji

class ReactionList extends CollectionWithHelpers
  model: Reaction

  initialize: ->
    @_pendingReactionUpdates = {}

  comparator: (reaction) ->
    Util.idToDate(reaction.id)

  findMyReaction: (idEmoji) ->
    @find (entry) =>
      entry.get('idMember') == Auth.myId() &&
      entry.get('idEmoji') == idEmoji

  getAction: (idAction) ->
    @modelCache?.get('Action', idAction)

  getUniqueCount: ->
    _.uniq(@models, false, getIdEmoji).length

  isNewPile: (reactionList, idEmoji) ->
    # returns true if adding reaction with idEmoji will create a new pile
    !_.some reactionList.models, (reaction) ->
      return getIdEmoji(reaction) == idEmoji

  reload: (idAction) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadReactions(idAction)
    .catch =>
      # We may have lost access to see the reactions.
      # Remove all reactions related to this action from the modelcache.
      @modelCache.all('Reaction').filter((reaction) ->
        reaction.get('idModel') == idAction
      ).forEach((reaction) => @modelCache.remove(reaction))

  # Track function Returns true or false, for added or removed, respectively.
  toggleReaction: (idAction, emoji, trackFn) ->
    idEmoji = emoji.unified.toUpperCase()

    if (existing = @findMyReaction(idEmoji))
      @remove(existing)
      @_registerReactionUpdate
        idReaction: idEmoji,
        updateFn: =>
          trackFn(false)
          existing.destroy({
            error: (model, { status, responseJSON }) =>
              @trigger('removeReactionError')
              # We've destroyed the model, and we need to reconcile the state
              # try reloading
              @reload(idAction)
          })
        model: existing
    else
      actionModel = @getAction(idAction)
      reactionLimits = actionModel?.get('limits')?.reactions
      if actionModel?.isOverUniqueReactionsCapacity() &&
      @isNewPile(actionModel.reactionList, idEmoji)
        @trigger('uniqueReactionLimit', reactionLimits?.uniquePerAction)
        return

      if actionModel?.isOverTotalReactionsCapacity()
        @trigger('totalReactionLimit', reactionLimits?.perAction || actionModel.reactionList.length)
        return

      model = @_pendingReactionUpdates[idEmoji]?.model ||
        new Reaction {
          idModel: idAction
          idMember: Auth.myId()
          idEmoji: idEmoji
          # this emoji object is not needed for the server payload
          # but allows us to render the reaction immediately upon adding to the model
          emoji: emoji
        }, { @modelCache }
      @_registerReactionUpdate
        idReaction: idEmoji,
        updateFn: =>
          trackFn(true)
          model.save null,
            error: (model, { status, responseJSON }) =>
              # Because we cache requests it's possible that the client
              # manged to add more reactions than the server allows
              # if we error because of this let's alert the user and remove
              # the reactions that were added
              message = responseJSON?.error
              if message?
                # It's possible we've not loaded the reactionsLimits, as they
                # are loaded with the action model, which is not loaded when
                # loading reactions via the notifications. Calculate the limit
                # based on what we have locally as a best effort.
                if message == 'ACTION_TOO_MANY_UNIQUE_REACTIONS'
                  @trigger(
                    'uniqueReactionLimit',
                    reactionLimits?.uniquePerAction ||
                    { disableAt: (@getUniqueCount() - 1) })
                else if message == 'ACTION_TOO_MANY_TOTAL_REACTIONS'
                  @trigger(
                    'totalReactionLimit',
                    reactionLimits?.perAction ||
                    { disableAt: @models.length - 1 })
              else
                @trigger('addReactionError')
              @reload(idAction)
              model.destroy()
        model: model

  _registerReactionUpdate: ({ idReaction, updateFn, model }) ->
    if @_pendingReactionUpdates[idReaction]?
      # Remove from pending updates, the user has just cancelled that operation
      delete @_pendingReactionUpdates[idReaction]
      model.destroy()
    else
      @_pendingReactionUpdates[idReaction] = {
        updateFn,
        model
      }

    @_debouncedPersistUpdates()

  _debouncedPersistUpdates: _.debounce ->
    _.each @_pendingReactionUpdates, ({ updateFn }) -> updateFn()
    @_pendingReactionUpdates = {}
  , 1000

module.exports = ReactionList
